import { Button } from "@win-reality/react-ui";
import { useDispatch, useSelector } from "react-redux";

import { resetTaggingFlowStep } from "../../../../store/slices/hotkeys";
import {
  resetAllTags,
  setTaggingState,
} from "../../../../store/slices/session";
import {
  resetEventQueue,
  setStaleEvents,
} from "../../../../store/slices/socket";
import { selectRecentEvent } from "../../../../store/slices/socket/selectors";
import { setModalState } from "../../../../store/slices/view";
import { SubmissionButton } from "./SubmissionButton";

/**
 * BottomButtons - Action buttons for tagging workflow
 *
 * Left side:
 * - Clear Metrics: Clears event queue and marks events as stale
 * - Change Sport: Opens modal to manually override sport (baseball/softball)
 * - End Session: Opens confirmation modal to end the current game
 *
 * Right side:
 * - Reset Tags: Resets all tags to default state
 * - Submit/Update: Saves tags for current or focused event
 *
 * Features:
 * - Dispatches Redux actions to manage tagging state
 * - Clear Metrics moves events to stale list
 * - Reset Tags clears all tag selections and returns to step 1
 */
export const BottomButtons = () => {
  const dispatch = useDispatch();
  const recentEvent = useSelector(selectRecentEvent);

  const handleClearMetrics = () => {
    dispatch(resetEventQueue());
    dispatch(setStaleEvents(recentEvent.contributing_events || []));
  };

  const handleResetTags = () => {
    dispatch(setTaggingState(false));
    dispatch(resetAllTags(undefined));
    dispatch(resetTaggingFlowStep());
  };

  const handleChangeSport = () => {
    dispatch(setModalState({ state: "Change Sport", data: {} }));
  };

  const handleEndSession = () => {
    dispatch(setModalState({ state: "End Session", data: {} }));
  };

  return (
    <div className="flex w-full justify-between">
      {/* Left side buttons */}
      <div className="flex gap-2">
        <Button variant="secondary-flat-light" onClick={handleClearMetrics}>
          Clear Metrics
        </Button>
        <Button variant="secondary-flat-light" onClick={handleChangeSport}>
          Change Sport
        </Button>
        <Button variant="secondary-flat-light" onClick={handleEndSession}>
          End Game
        </Button>
      </div>

      {/* Right side buttons */}
      <div className="flex gap-2">
        <Button variant="secondary-flat-light" onClick={handleResetTags}>
          Reset Tags
        </Button>
        <SubmissionButton />
      </div>
    </div>
  );
};
